module.exports = __webpack_public_path__ + "media/images/pages/trade-gdpr-c2772d47ad0f867da894c4e98d05f591.svg";